import { render } from "./whatClientsSay.vue?vue&type=template&id=080a086e&scoped=true"
import script from "./whatClientsSay.vue?vue&type=script&lang=js"
export * from "./whatClientsSay.vue?vue&type=script&lang=js"

import "./whatClientsSay.vue?vue&type=style&index=0&id=080a086e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080a086e"]])

export default __exports__